<app-auth-container
	label="Log in"
	description="Experience the platform designed to carry your firm forward."
	submitButtonText="Log In"
	[loading]="loginLoading$ | async"
	[formGroup]="authForm"
	[disabled]="loginLoading$ | async"
	(onFormSubmit)="submit()"
>
	<ng-container form-content>
		<app-input
			class="font-light"
			label="Email"
			[formControlName]="USER_CREDENTIALS.EMAIL"
			type="email"
			[testHook]="testHooks.Email"
		></app-input>

		<fieldset class="flex flex-col">
			<app-input
				class="font-light"
				label="Password"
				[formControlName]="USER_CREDENTIALS.PASSWORD"
				type="password"
				class="mt-3"
				[testHook]="testHooks.Password"
			></app-input>
			<app-anchor
				type="static"
				[url]="forgetUrl"
				[testHook]="testHooks.ForgotPassword"
				>Forgot password?</app-anchor
			>
		</fieldset>
	</ng-container>

	<ng-container footer-content>
		<p>Don't have an account yet?</p>
		<app-anchor type="bold" [url]="signUpUrl" [testHook]="testHooks.SignUpLink"
			>Sign up</app-anchor
		>
	</ng-container>
</app-auth-container>
